// Shared framer-motion variants for consistent, organic choreography
export const EASE = [0.16, 1, 0.3, 1];

export const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, ease: EASE },
  },
};

export const fadeIn = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { duration: 1, ease: EASE } },
};

export const staggerContainer = {
  hidden: {},
  visible: {
    transition: { staggerChildren: 0.12, delayChildren: 0.1 },
  },
};

export const maskLine = {
  hidden: { y: "110%" },
  visible: {
    y: "0%",
    transition: { duration: 0.9, ease: EASE },
  },
};

export const scaleImage = {
  hidden: { scale: 1.15, opacity: 0 },
  visible: { scale: 1, opacity: 1, transition: { duration: 1.2, ease: EASE } },
};

// ============================================================================
// Brand assets — ALL PHOTO/PDF URLs INTENTIONALLY EMPTY
// ----------------------------------------------------------------------------
// The site now uses branded placeholder frames wherever a photo would go.
// To add real assets later, paste the URL into the matching key below and the
// component will automatically render the real asset instead of the placeholder.
// ============================================================================
export const IMAGES = {
  logo: null,            // Company logo (transparent PNG recommended)
  heroWheat: null,       // Full-viewport hero background photo
  facility: null,        // Facility / landscape photo (About + Contact)
  ddgsPiles: null,       // DDGS product piles photo
  founderAyush: null,    // Founder portrait — Ayush Singhania
  founderYash: null,     // Founder portrait — Yash Kumar Harlalka
  teaPlantation: null,   // Assam tea plantation photo (Tea section)
  spicesMarket: null,    // Spices imagery
  cornGrain: null,       // Pure Maize DDGS photo
  riceGrain: null,       // Pure Rice DDGS photo
};

// Downloadable brochure PDF (leave null to hide all brochure download buttons)
export const BROCHURE_PDF = null;

export const WHATSAPP_URL =
  "https://wa.me/918638241548?text=Hi%20Agro%20Trade%20Global%2C%20I%27d%20like%20to%20enquire%20about%20your%20DDGS.";
